<div class="parceiros-container flex justify-between items-center px-29 py-6">
  <div class="trabalho-container flex items-center gap-6">
    <a href="https://www.ufpr.br" target="_blank">
      <img
        src="../../../../assets/logo-ufpr.png"
        alt="logo ufpr"
        id="ufpr-logo"
      />
    </a>

    <a href="https://www.ufg.br" target="_blank">
      <img
        src="../../../../assets/logo-ufg.png"
        alt="logo ufg"
        id="ufg-logo"
      />
    </a>

    <a href="https://www.usp.br" target="_blank">
      <img
        src="../../../../assets/logo-usp.png"
        alt="logo ufg"
        id="usp-logo"
      />
    </a>

  </div>

  <div class="realizacao-container flex items-center gap-6">
    <span class="text-body-md font-regular text-charcoal-800">realização:</span>
    <a href="https://dadoseducacionais.c3sl.ufpr.br/" target="_blank">
      <img
        src="../../../../assets/logo-lde.png"
        alt="logo lde"
        id="lde-logo"
      />
    </a>

    <a href="https://fabrica.inf.ufg.br/" target="_blank">
      <img
        src="../../../../assets/logo-roxored.png"
        alt="logo Fábrica de Software"
        id="fs-logo"
      />
    </a>

    <a href="https://site.funape.org.br/" target="_blank">
      <img
        src="../../../../assets/logo-funape.png"
        alt="logo Fábrica de Software"
        id="funape-logo"
      />
    </a>

    <a href="https://lamcad.ufg.br/" target="_blank">
      <img
        src="../../../../assets/logo-lamcad.png"
        alt="logo Fábrica de Software"
        id="lamcad-logo"
      />
    </a>

  </div>

  <div class="financiamento-container flex items-center gap-6">
    <span class="text-body-md font-regular text-charcoal-800">financiamento:</span>
    <img
      src="../../../../assets/governo-federal.svg"
      alt="logo governo federal"
      id="governo-federal-logo"
    />
  </div>
</div>
